import React from 'react'
import PropTypes from 'prop-types'
import H1 from 'src/components/shared/Headings/H1'
import Date from '../../shared/Date'
import Content from './Content'

const PressPostPage = ({ post }) => {
  const { title, imageAsset, content, customPublishedDate, updatedAt, slug } =
    post

  return (
    <div
      className="mx-auto mb-16 max-w-screen-lg lg:px-3 xl:px-0"
      data-testid="press-post-page"
    >
      <div className="max-w-2xl px-6 text-sm text-gray-500 sm:m-auto lg:px-0">
        <div className="mb-2 lg:mb-6">
          <H1
            className="mb-0 mt-4 text-3xl leading-10 text-blue-700 lg:text-4xl"
            text={title}
            id={title}
          />
        </div>
        <p className="mb-6">
          <Date date={customPublishedDate || updatedAt} />
        </p>
        <Content
          slug={slug}
          imageAsset={imageAsset}
          content={content}
          title={title}
        />
      </div>
    </div>
  )
}

PressPostPage.propTypes = {
  post: PropTypes.object.isRequired,
}
export default PressPostPage
